import { ResourceProps } from "react-admin";
import { VettingShow, VettingUsersList } from "./components";

export const vettingUsersResource: Omit<ResourceProps, "name"> = {
  list: VettingUsersList,
  show: VettingShow,
};
